import React from 'react';
import './HeroSection.css';

/**
 * HeroSection - Sección hero principal reutilizable
 * Muestra un título grande, subtítulo, descripción y CTA
 * Soporta imagen de fondo y foreground (como el MainLogo original)
 */
const HeroSection = ({
  title,
  subtitle,
  description,
  ctaText,
  ctaLink,
  backgroundImage,
  foregroundImage,
  showImages = true
}) => {
  const resolvedBackgroundImage = backgroundImage || '/Images/04.png';

  const handleCTA = () => {
    if (ctaLink) {
      if (ctaLink.startsWith('#')) {
        // Scroll to anchor
        const element = document.querySelector(ctaLink);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      } else {
        // Navigate to link
        window.location.href = ctaLink;
      }
    }
  };

  return (
    <div className="heroContainer">
      {/* Imágenes de fondo y foreground (estilo MainLogo) */}
      {showImages && resolvedBackgroundImage && (
        <>
          <img
            src={resolvedBackgroundImage}
            className="heroBackgroundImage"
            alt="background"
          />
          {foregroundImage && (
            <img
              src={foregroundImage}
              className="heroForegroundImage"
              alt="logo"
            />
          )}
        </>
      )}

      {/* Contenido del hero */}
      {(title || subtitle || description || ctaText) && (
        <div className="heroContent">
          {title && <h1 className="heroTitle">{title.toUpperCase()}</h1>}
          {subtitle && <h2 className="heroSubtitle">{subtitle.toUpperCase()}</h2>}
          {description && <p className="heroDescription">{description}</p>}
          {ctaText && (
            <button className="heroCTA pillButton pillButton--on-dark" onClick={handleCTA}>
              {ctaText.toUpperCase()}
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default HeroSection;
